import { FC, ReactNode } from 'react';

import { Container } from '@shared/ui/Container';
import { Tab, TabList, TabPanel, Tabs } from '@shared/ui/Tabs';

import cls from './MiddleTabs.module.scss';

type MiddleTabsProps = {
  tabs: Array<{
    value: number;
    ariaLabel: string;
    name: string;
    tabPanel: ReactNode;
  }>;
};

export const MiddleTabs: FC<MiddleTabsProps> = ({ tabs }) => {
  return (
    <div className={cls.wrap}>
      <Container>
        <Tabs>
          <TabList className={cls.tabs}>
            {tabs.map(({ ariaLabel, value, name }) => (
              <Tab
                key={name}
                activeClassName={cls.activeTab}
                {...{ ariaLabel, value }}
              >
                {name}
              </Tab>
            ))}
          </TabList>
          {tabs.map(({ tabPanel, value }) => (
            <TabPanel
              key={value}
              value={value}
            >
              {tabPanel}
            </TabPanel>
          ))}
        </Tabs>
      </Container>
    </div>
  );
};
